import { Data } from 'signup-constants/signupData/Data';
import { setIsFreeEmailDomain } from '../store/app/action-creators';
import { bulkSetSignupDataAndSetValid, bulkUpdateGtkmData, setSignupDataValue } from '../store/signup-data/action-creators';
import { EndpointKey } from '../http/EndpointKey';
import { getEndpointRetries } from '../store/http-responses/selectors';
import { setEndpointTimeCompleted } from '../store/http-responses/action-creators';
import { getCompanySizeOptionFromEmployeesRange } from '../company-info/companySize';
import { Tracker } from '../store/tracking/action-creators';
import { getGTKMDomainToUse, getGTKMFallbackDomain } from './gtkmDomainUtils';
import { getSentryExtra } from '../error/getSentryExtra';
import { LOG } from '../http/HttpRequester';
import { updateStepOrderSU0004, advanceToReviewAfterDomainSU0004 } from './updateStepOrderSU0004';
export const handleSU0004GTKMCompanyInfoSuccess = ({
  domain,
  name,
  industry,
  companySizeLowerBracket,
  companySizeUpperBracket,
  isFreeEmailDomain
}, dispatch, getState) => {
  const state = getState();
  dispatch(Tracker.signupInteraction('gtkm-company-info-prefill-success'));
  dispatch(Tracker.signupInteraction('gtkm-company-info-is-freemail', {
    currentValue: isFreeEmailDomain
  }));
  if (isFreeEmailDomain) {
    dispatch(setIsFreeEmailDomain());
  }
  const gtkmDataWithoutDomain = {
    [Data.CompanySize]: companySizeLowerBracket && companySizeUpperBracket ? getCompanySizeOptionFromEmployeesRange({
      min: companySizeLowerBracket,
      max: companySizeUpperBracket
    }) : '',
    [Data.CompanyName]: name || '',
    [Data.Industry]: industry || ''
  };
  const gtkmData = Object.assign({}, gtkmDataWithoutDomain, {
    [Data.CompanyDomain]: domain || ''
  });
  dispatch(bulkUpdateGtkmData(gtkmData));
  dispatch(bulkSetSignupDataAndSetValid(gtkmDataWithoutDomain));
  const retries = getEndpointRetries(state, EndpointKey.GTKMCompanyInfoSU0004);
  if (!isFreeEmailDomain && retries < 1) {
    dispatch(setSignupDataValue(Data.CompanyDomain, domain || ''));
  }
  dispatch(setEndpointTimeCompleted(EndpointKey.GTKMCompanyInfoSU0004, new Date()));
  if (retries < 1) {
    updateStepOrderSU0004({
      gtkmData: {
        [Data.CompanyDomain]: domain || ''
      },
      dispatch,
      state,
      isFreeEmailDomain
    });
  } else {
    advanceToReviewAfterDomainSU0004({
      gtkmData: {
        [Data.CompanyDomain]: domain || ''
      },
      dispatch,
      state
    });
  }
};
export const handleSU0004GTKMCompanyInfoError = (error, dispatch, getState) => {
  const state = getState();
  dispatch(Tracker.signupInteraction(`gtkm-company-info-prefill-error-${error.status}`));
  const gtkmDomain = getGTKMDomainToUse(state);
  dispatch(bulkUpdateGtkmData({
    [Data.CompanyDomain]: gtkmDomain
  }));
  const retries = getEndpointRetries(state, EndpointKey.GTKMCompanyInfoSU0004);
  if (retries < 1) {
    const fallbackDomain = getGTKMFallbackDomain(state);
    dispatch(setSignupDataValue(Data.CompanyDomain, fallbackDomain));
  }
  LOG.error('GTKM Company Information Request Failed', {
    extra: Object.assign({}, getSentryExtra(error), {
      gtkmDomain
    })
  });
  const gtkmData = {
    [Data.CompanyDomain]: gtkmDomain
  };
  if (retries < 1) {
    updateStepOrderSU0004({
      gtkmData,
      dispatch,
      state,
      isGTKMEndpointFailed: true
    });
  } else {
    advanceToReviewAfterDomainSU0004({
      gtkmData,
      dispatch,
      state
    });
  }
};